import {Injectable} from './di';
import {importStyle} from './utils/import-style';
import {AppInitializeService} from './app-initialize-service';

/**
 * This service encapsulates legacy loader logic entry point
 */
@Injectable()
export class LegacyCustomCssLoaderService implements AppInitializeService {
  public async init(): Promise<boolean> {
    await this.loadCustomCss();
    return true;
  }

  private async loadCustomCss(): Promise<void> {
    // NOTE: custom/config.css and config.css is legacy stuff, but we still need to support it.

    // But it seems we almost never supply them. But missing files cause root errors.
    // TODO: rewrite to load css by fetch and load into style tag manually to avoid console error pollution
    try {
      try {
        return await importStyle('custom/config.css', 'customization_css', undefined, undefined, true, true);
      } catch {
        return await importStyle('tv/config.css', 'customization_css_old', undefined, undefined, true, true);
      }
    } catch {
      // suppress rejection, because both files could be missed
    }
  }
}
